module.exports = __webpack_public_path__ + "static/media/care-com.6aa7d1db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social-proof/care-com.svg
// module id = 2086
// module chunks = 0